import { apiClient, unwrap } from '@services/api';
import type {
  ChartPoint,
  FinanceCustomer,
  FinanceHistory,
  FinanceWholesalerAccount,
  Transaction,
} from '@/types';

export const financeService = {
  async getCustomers(): Promise<FinanceCustomer[]> {
    const res = await apiClient.get<FinanceCustomer[]>('/wholesaler/customers');
    return unwrap(res);
  },

  async getCustomerHistory(restaurantId: string): Promise<FinanceHistory> {
    const res = await apiClient.get<FinanceHistory>(
      `/wholesaler/customer/${restaurantId}/history`,
    );
    return unwrap(res);
  },

  async recordPayment(data: {
    restaurantId: string;
    amount: number;
    paymentMethod: string;
    description?: string;
  }): Promise<{ balance: number; transaction: Transaction }> {
    const res = await apiClient.post<{ balance: number; transaction: Transaction }>(
      '/wholesaler/customer/payment',
      data,
    );
    return unwrap(res);
  },

  async getRestaurantAccounts(): Promise<FinanceWholesalerAccount[]> {
    const res = await apiClient.get<FinanceWholesalerAccount[]>('/restaurant/cari');
    return unwrap(res);
  },

  async getRestaurantHistory(wholesalerId: string): Promise<FinanceHistory> {
    const res = await apiClient.get<FinanceHistory>(
      `/restaurant/cari/${wholesalerId}/history`,
    );
    return unwrap(res);
  },

  async getSpendingChart(wholesalerId?: string): Promise<ChartPoint[]> {
    const res = await apiClient.get<ChartPoint[]>('/restaurant/finance/chart', {
      params: wholesalerId ? { wholesalerId } : undefined,
    });
    return unwrap(res);
  },
};
